import 'rc-slider/assets/index.css';
import 'rc-tooltip/assets/bootstrap.css';
import React, {Component} from 'react';
import {unByKey} from 'ol/Observable';
import { Card, /*, Accordion, Button*/ 
Button} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripLines, faTimes, faShareAlt, faCog } from "@fortawesome/free-solid-svg-icons";
import Tooltip from 'rc-tooltip';
import Slider from 'rc-slider';
import {updateTileLayerDateRange} from "./mapInit";
import '../styles/MapLayer.scss';
import ModalShareLayer from './modals/ModalShareLayer';
import ModalConfigureLayer from './modals/ModalConfigureLayer';
import Gradient from './Gradient';
import { scales } from '../colorscaleUtils';
import moment from 'moment';

const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);
const Handle = Slider.Handle;
const handle = (props: any) => {
  const { value, dragging, index, ...restProps } = props;
  return (
    <Tooltip
      prefixCls="rc-slider-tooltip"
      overlay={value}
      visible={dragging}
      placement="top"
      key={index}
    >
      <Handle value={value} {...restProps} />
    </Tooltip>
  );
};

export default class MapLayerAndDateRange extends Component<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            visible: props.layer.getVisible(),
            yearStart: props.layer.get('yearStart'),
            yearEnd: props.layer.get('yearEnd'),
            showLayerShareModal: false,
            showLayerConfigureModal: false,
        }

        this.yearStartMin = props.layer.get('yearStartMin');
        this.yearEndMax = props.layer.get('yearEndMax');
      
        this.dwLayerLegend = false;
        this.dwLayerLegendFields = false;
        this.dwLayerSTACRamp = false;
        this.dwLayerLegendColor = { 
          backgroundColor: 'red',
        }
        if (this.props.layer.values_.dataSourceRow){
          if (this.props.layer.values_.dataSourceRow.color_ramp){
            this.dwLayerSTACRamp = true;
          }
        }
        if (this.props.layer.dwdataLayerStyle){
          this.dwLayerLegend = true;
          this.dwLayerLegendColor = { 
            backgroundColor: this.props.layer.dwdataLayerStyle.highRenderedColor,
          }
          if (this.props.layer.dwdataLayerStyle.layerType === "GeoJSON"){ // A polylgon (field) layer
            this.dwLayerLegendFields = true;
          }
        }
    }

    private yearStartMin: number;
    private yearEndMax: number;
    private dwLayerLegend : boolean;
    private dwLayerLegendFields : boolean;
    private dwLayerSTACRamp : boolean;
    private dwLayerLegendColor : any;

    /* make sure event listeners get destroyed when component is reloaded
     */
    private changeVisibleKey = null;
    private propertyChangeKey = null;

    handleAutoUpdate(){
      console.log("A011022 AUTOUpdate");
    }

    // @Listen('drop')
    handleDrop(evt: any) {
        console.log('handleDrop', this.props.layer.get('title'), evt.dataTransfer.getData('text/plain'));
        const draggedTitle = evt.dataTransfer.getData('text/plain');
        const droppedTitle = this.props.layer.get('title');
        this.props.emitLayerListOrderChange(draggedTitle, droppedTitle);
    }

    componentDidMount() {
        this.props.layer["MapLayerAndDateRange"] = this;
        console.log('componentDidLoad', this.props.layer.get('title'), this.changeVisibleKey);
        this.changeVisibleKey = this.props.layer.on('change:visible', () => {
            this.setState({
                visible: this.props.layer.getVisible(),
            });
        });

        this.propertyChangeKey = this.props.layer.on('propertychange', () => {
            const yearStart = this.props.layer.get('yearStart');
            const yearEnd = this.props.layer.get('yearEnd');
            console.log('layer propertychange', yearStart, yearEnd);
            this.setState((state: any) => {
                const newState: any = {};
                if (yearStart !== state.yearStart) {
                    newState.yearStart = yearStart;
                }
                if (yearEnd !== state.yearEnd) {
                    newState.yearEnd = yearEnd;
                }
                return newState;
            });
        });
    }

    /*
     * Component will get reloaded when list is re-ordered (due to key= prop
     * on this component; this is necessary so stencil doesn't try and re-use
     * DOM elements which apparently messes up references to `this` in event callbacks),
     * so we need to prevent event listeners from piling up.
     */
    componentWillUnmount() {
        console.log('componentDidUnload', this.props.layer.get('title'), this.changeVisibleKey);
        if (this.changeVisibleKey) {
            unByKey(this.changeVisibleKey);
        }
        if (this.propertyChangeKey) {
            unByKey(this.propertyChangeKey);
        }
    }

    emitLayerDateRangeChange(yearStart: any, yearEnd: any) {
        console.log("yearStart, yearEnd", yearStart, yearEnd)
        this.props.layer.setProperties({
            yearStart: parseInt(yearStart),
            yearEnd: parseInt(yearEnd),
        });
        // TODO this is duplicated in map.ts
        var startTime = `${yearStart}-01-01`;
        var endTime = `${yearEnd}-01-01`;
        if (this.props.layer.values_.dataSourceRow){
          if (this.props.layer.values_.dataSourceRow.date_display_resolution === "year"){
            startTime = `${yearStart}-01-01`;
            endTime = `${yearEnd}-01-01`;
          }
          if (this.props.layer.values_.dataSourceRow.date_display_resolution === "day"){
            startTime = this.convertFromEpoch(yearStart - 1);
            endTime = this.convertFromEpoch(yearEnd + 1);
          }
        }
        updateTileLayerDateRange(this.props.layer, startTime, endTime, "emitLayerDateRangeChange");
        this.props.emitLayerList('layerChange',null,null,null,"emitLayerDateRangeChange");
    }

    handleDWDateRangeChange(yearStart: any, yearEnd: any) {
        console.log("yearStart, yearEnd", yearStart, yearEnd)
        this.props.layer.setProperties({
            yearStart: parseInt(yearStart),
            yearEnd: parseInt(yearEnd),
        });
        var startTime = this.convertFromEpoch(yearStart);
        var endTime = this.convertFromEpoch(yearEnd);
        //updateTileLayerDateRange(this.props.layer, startTime, endTime, "emitLayerDateRangeChange");
        //this.props.emitLayerList('layerChange',null,null,null,"emitLayerDateRangeChange");
    }

    emitLayerVisibilityChange() {
        console.log("emitLayerVisibilityChange FROM", this.state.visible)
        console.log("emitLayerVisibilityChange TO", !this.state.visible)
        this.props.layer.setVisible(!this.state.visible);
        this.props.emitLayerList('layerChange',null,null,null,"emitLayerVisibilityChange");
    }

    handleSliderChangeDW(evt: any) {
      console.log("C122821 evt", evt)  
        const [yearStart, yearEnd] = evt;
        this.setState({
            yearStart,
            yearEnd,
        });
    }

    handleAfterSliderChangeDW(evt: any) {
      console.log("C122821 evt", evt)  
      const [yearStart, yearEnd] = evt;
      this.handleDWDateRangeChange(yearStart, yearEnd);
    }

    handleSliderChange(evt: any) {
        const [yearStart, yearEnd] = evt;
        this.setState({
            yearStart,
            yearEnd,
        });
    }

    handleAfterSliderChange(evt: any) {
        const [yearStart, yearEnd] = evt;
        this.emitLayerDateRangeChange(yearStart, yearEnd);
    }

    handleFormatSliderChange(v: any) {
        var dateFormatted = "";
        //console.log("v",v)
        if (v  <= 2100){ // The value is in years, display as-is.
          dateFormatted = v;
        }else{
          var valueFromEpoch = ((v) * 8.64e7)
          //console.log("valueFromEpoch",valueFromEpoch)
          var dateFromEpoch = new Date(valueFromEpoch);
          //console.log("dateFromEpoch",dateFromEpoch)
          var ye = dateFromEpoch.toLocaleDateString("en-US", { year: 'numeric' });
          var mo = dateFromEpoch.toLocaleDateString("en-US", { month: 'numeric' });
          var da = dateFromEpoch.toLocaleDateString("en-US", { day: 'numeric' });
          if (mo.length < 2){
            mo = "0" + mo;
          }
          if (da.length < 2){
            da = "0" + da;
          }
          dateFormatted = `${ye}-${mo}-${da}`;
        }
        //console.log("dateFormatted", dateFormatted)
        return dateFormatted;
    }

    convertFromEpoch(daysFromEpoch:any){
      var valueFromEpoch = ((daysFromEpoch) * 8.64e7)
      var dateFromEpoch = new Date(valueFromEpoch);
      var ye = dateFromEpoch.toLocaleDateString("en-US", { year: 'numeric' });
      var mo = dateFromEpoch.toLocaleDateString("en-US", { month: 'numeric' });
      var da = dateFromEpoch.toLocaleDateString("en-US", { day: 'numeric' });
      if (mo.length < 2){
        mo = "0" + mo;
      }
      if (da.length < 2){
        da = "0" + da;
      }
      var dateFormatted = `${ye}-${mo}-${da}`;
      //console.log("dateFormatted convertFromEpoch", dateFormatted)
      return dateFormatted;
    }

    onHandleCloseShareLayerModal(evt: any) {
      this.setState({
        showLayerShareModal: false
      });
    }

    onHandleCloseConfigureLayerModal(evt: any) {
      this.setState({
        showLayerConfigureModal: false
      });
    }    
    
    onSaveNewLayerName(_layer:any) {
      console.log("onSaveNewLayerName()")
      //this.props.emitLayerList('layerNameChange',null,null,null,"onSaveNewLayerName");
      this.props.emitLayerList('layerStyleChange',null,null,_layer,"handleLayerStyleChange");
      //this.props.emitLayerList('layerOrderChange',null,null,null,"handleLayerOrderChange");
    }

    async onHandleShareLayer(widgetInstance: any) {
      //do nothing for now
    }

    async onHandleConfigureLayer(widgetInstance: any) {
      //do nothing for now
    }
    
    numberWithCommas(y:number) {
      try{
        var x:number = Math.round((y + Number.EPSILON) * 100) / 100 // <-- use * 1000) / 1000 for 3 digits.
        if (x >= 1000){
          return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }else{
          return x.toString();
        }
      }catch(err){
        return "";
      }
    }

    render() {
        const layer = this.props.layer;
        const visible = this.state.visible;
        /*console.log("MapLayerAndDateRange render() > layer", layer)
        console.log("MapLayerAndDateRange render() > visible", visible)
        console.log("this.props.dragHandleProps", this.props.dragHandleProps)
        console.log("this.props", this.props)*/
        const sliderWrapperStyle = { 
          margin: '10px',           
          marginBottom: '20px',
        };        
        
        const dwLayerLegendWrapperStyle = { 
          display: 'flex',
        };

        var marks: any = {};
        // no slider     => {2010: 2010}
        // slider (year) => {2013: 2013, 2015: 2015, 2017: 2017, 2019: 2019}
        // slider (day)  => {...}
        let spacing = 1;
        var minDaysSinceEpoch = null;
        var maxDaysSinceEpoch = null;
        //console.log("this.props", this.props)
        //console.log("this.state", this.state)
        //console.log("this.yearStartMin", this.yearStartMin)
        //console.log("this.yearEndMax", this.yearEndMax)
        if (layer.dwdataLayerStyle && layer.dwdataLayerStyle.maxDate){
          //console.log("layer.dwdataLayerStyle.maxDate", layer.dwdataLayerStyle.maxDate)
          //console.log("layer.dwdataLayerStyle.minDate", layer.dwdataLayerStyle.minDate)
          // Prepare year start/end marks for DW field layers
          if (layer.dwdataLayerStyle.maxDate && layer.dwdataLayerStyle.minDate){
              let momentDateMin = moment(layer.dwdataLayerStyle.minDate).format('YYYY-MM-DD');
              var minDate:any = new Date(momentDateMin);
              minDaysSinceEpoch = Math.floor(minDate/8.64e7);
              marks[minDaysSinceEpoch] = momentDateMin;
              let momentDateMax = moment(layer.dwdataLayerStyle.maxDate).add(7, 'days').format('YYYY-MM-DD');// Add extre days so that the user can actually slide that far right.
              var maxDate:any = new Date(momentDateMax);
              maxDaysSinceEpoch = Math.floor(maxDate/8.64e7);
              marks[maxDaysSinceEpoch] = momentDateMax;
              
          }
        }
        //console.log("layer", layer)
        // Prepare year start/end marks for STAC/Tile layers
        let styleSliderClass = "syncarto-rc-slider-day";
        if (layer.values_.dataSourceRow){
          if (layer.values_.dataSourceRow.date_display_resolution === "year"){
            if (this.yearEndMax - this.yearStartMin > 3) {
                spacing = 2;
            }
            for (let i=this.yearStartMin; i<=this.yearEndMax; i+=spacing) {
                marks[i] = i;
            }
            styleSliderClass = "syncarto-rc-slider-year";
          }
          if (layer.values_.dataSourceRow.date_display_resolution === "day"){
            //marks = {2020: 2020}
            //if (this.yearEndMax - this.yearStartMin > 3) {
                //spacing = (this.yearEndMax - this.yearStartMin) / 4;
                //spacing = 2;
            //}
            //for (let i=this.yearStartMin; i<=this.yearEndMax; i+=spacing) {
            //   marks[i] = this.convertFromEpoch(i);
            //}
            marks[this.yearStartMin] = this.convertFromEpoch(this.yearStartMin);
            marks[this.yearEndMax] = this.convertFromEpoch(this.yearEndMax);
          }
        }
        //console.log("title",this.props.layer.get("title"));
        return (
          <div>
          <Card>
            <Card.Body>
              <div className="layerTitleRow">
                {/* add dragHandleProps to the bit that you want to be able
                    to actually grab (we need to not break the date slider!
                    Note, per react-beautiful-dnd docs, interactive elements
                    are automatically blocked from dragging, but since no-ui-slider
                    is just implemented with divs, that doesn't help us here
                */}
                <div {...this.props.dragHandleProps} className="start">
                  <FontAwesomeIcon icon={faGripLines} />
                </div>
                <div className="start">
                   { /* requires no-op in onChange to satisfy proptypes */ }
                  <input type="checkbox"
                    checked={visible}
                    onClick={() => this.emitLayerVisibilityChange()}
                    onChange={() => null}
                  />
                </div>
                <div className="end">
                  { 
                  // eslint-disable-next-line
                  }
                  <a href="" className="syncarto-map-layers-control-button" onClick={(e: any) => e.preventDefault()} >
                    <FontAwesomeIcon icon={faShareAlt} size="xs"
                     onClick={() => this.setState({showLayerShareModal: true})} />
                  </a>
                  <a href="" className="syncarto-map-layers-control-button" onClick={(e: any) => e.preventDefault()} >
                    <FontAwesomeIcon icon={faCog} size="xs"
                     onClick={() => this.setState({showLayerConfigureModal: true})} />
                  </a>
                  <a href="" className="syncarto-map-layers-control-button" onClick={(e: any) => e.preventDefault()} >
                    <FontAwesomeIcon icon={faTimes} size="xs"
                     onClick={() => this.props.emitLayerList('layerChange', null, this.props.layer,null,"onClick delete x")} />
                  </a>
                </div>
              </div>
              <div className="syncarto-map-layers-title">{layer.get('title')}</div>
              {this.yearStartMin !== this.yearEndMax ?
                <div className={styleSliderClass} style={sliderWrapperStyle}>
                  <Range min={this.yearStartMin} max={this.yearEndMax} 
                     value={[this.state.yearStart, this.state.yearEnd]}
                     handle={handle} onChange={(e: any) => this.handleSliderChange(e)} 
                     onAfterChange={(e: any) => this.handleAfterSliderChange(e)} 
                     tipFormatter={this.handleFormatSliderChange} 
                     marks={marks}
                     step={1}
                  />
                </div> : null
              }  
              {  
                this.dwLayerLegend && this.props.layer.dwdataLayerStyle.highRenderedColor && this.props.layer.dwdataLayerStyle.highRenderedColor.scale ?
                <div className="mt-2">
                  <Gradient width={190} height={20} ramp={scales[this.props.layer.dwdataLayerStyle.highRenderedColor.scale]} inverse={this.props.layer.dwdataLayerStyle.highRenderedColor.inverse} />
                </div>
                : null
              }          
              {    
              this.dwLayerLegend ?
                this.dwLayerLegendFields ?
                  <div style={dwLayerLegendWrapperStyle}>
                    <div className="dw-layer-legend-low" style={{backgroundColor:'#ff000000', right:'8px', top:'0px'}}>
                      <div className="dw-layer-legend-low-text">{this.numberWithCommas(this.props.layer.dwdataLayerStyle.minVal)}</div>
                    </div> 
                    <div className="dw-layer-legend-high" style={{backgroundColor:'#ff000000', left: 'calc(100% - 0px)', top:'0px'}}>
                      <div className="dw-layer-legend-high-text">{this.numberWithCommas(this.props.layer.dwdataLayerStyle.maxVal)}</div>
                    </div> 
                  </div> : 
                  <div style={dwLayerLegendWrapperStyle}>
                  <div className="dw-layer-legend-low" style={{backgroundColor:'#ff000000', right:'8px', top:'0px'}}>
                    <div className="dw-layer-legend-low-text">{this.numberWithCommas(this.props.layer.dwdataLayerStyle.minVal)}</div>
                  </div> 
                  <div className="dw-layer-legend-high" style={{backgroundColor:'#ff000000', left: 'calc(100% - 0px)', top:'0px'}}>
                    <div className="dw-layer-legend-high-text">{this.numberWithCommas(this.props.layer.dwdataLayerStyle.maxVal)}</div>
                  </div> 
                </div> : null
              }

              {
                this.dwLayerSTACRamp ? <>
                <div className="mt-2">
                  <Gradient width={190} height={20} ramp={JSON.parse(this.props.layer.values_.dataSourceRow.color_ramp)} inverse={false} />
                </div>
                <div style={dwLayerLegendWrapperStyle}>
                  <div className="dw-layer-legend-low" style={{backgroundColor:'#ff000000', right:'8px', top:'0px'}}>
                    <div className="dw-tile-layer-legend-low-text">{this.numberWithCommas(this.props.layer.values_.dataSourceRow.global_min)}</div>
                  </div> 
                  <div className="dw-layer-legend-high" style={{backgroundColor:'#ff000000', left: 'calc(100% - 0px)', top:'0px'}}>
                    <div className="dw-tile-layer-legend-high-text">{this.numberWithCommas(this.props.layer.values_.dataSourceRow.global_max)}</div>
                  </div> 
                </div> 
                </>
                : null
              }             
              {
              /* Add accordion to the layer in layer list - CS, work in progress
              layer.get('title') === "Analysis" ?
                <Accordion defaultActiveKey="0">
                  <Card>
                    <Card.Header>
                      <Accordion.Toggle as={Button} variant="link" eventKey="0">Open/close Legend</Accordion.Toggle>
                    </Card.Header>
                    <Accordion.Collapse eventKey="0">
                      <Card.Body>{layer.get('title')} Legend</Card.Body>
                    </Accordion.Collapse>
                  </Card>
                </Accordion> : null
              */
              }
            </Card.Body>
          </Card>
          <ModalShareLayer
            show={this.state.showLayerShareModal}
            onHandleClose={(e: any) => this.onHandleCloseShareLayerModal(e)}
            onCopyURL={(e: any) => this.onHandleShareLayer(e)}
            layer={this.props.layer}
          />          
          <ModalConfigureLayer
            show={this.state.showLayerConfigureModal}
            onHandleClose={(e: any) => this.onHandleCloseConfigureLayerModal(e)}
            onSaveNewLayerName={(_layer:any) => this.onSaveNewLayerName(_layer)}
            layer={this.props.layer}
            dwDefinition={this.props.dwDefinition}
            configUpdated={(queryConfig: any, _layer:any) => this.props.configUpdated(queryConfig, _layer)}
            layerStyleUpdated={(highColor:any, lowColor:any, highPoint: any, lowPoint: any, _layer: any, max:any, min:any) => this.props.layerStyleUpdated(highColor, lowColor, highPoint, lowPoint, _layer, max, min)}
            updateDwLayers={() => this.props.updateDwLayers()}
            definitionWrappers={this.props.definitionWrappers}
          />
          </div>
        );
    }
}
